import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    trainingSystems: [],
    courses: [],
    semesters: [],
    subjects: [],
    creditClasses: [],
    points: [],
    students: [],
  },
  getters: {
    trainingSystems: state => state.trainingSystems,
    courses: state => state.courses,
    semesters: state => state.semesters,
    subjects: state => state.subjects,
    creditClasses: state => state.creditClasses,
    points: state => state.points,
    students: state => state.students,
  },
  mutations: {
    SET_TRAINING_SYSTEMS: (state, data) => { state.trainingSystems = data },
    SET_COURSES: (state, data) => { state.courses = data },
    SET_SEMESTERS: (state, data) => { state.semesters = data },
    SET_SUBJECTS: (state, data) => { state.subjects = data },
    SET_CREDIT_CLASSES: (state, data) => { state.creditClasses = data },
    SET_POINTS: (state, data) => { state.points = data },
    SET_STUDENTS: (state, data) => { state.students = data },
  },
  actions: {
    async getTrainingSystemsByOrganizationId({ commit }, params) {
      try {
        const response = await axios.get('uni/trainingSystems/getByOrganizationId', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_TRAINING_SYSTEMS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getCoursesByTrainingSystemId({ commit }, params) {
      try {
        const response = await axios.get('uni/courses/getByTrainingSystemId', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_COURSES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getSemestersByCourseId({ commit }, params) {
      try {
        const response = await axios.get('uni/semesters/getByCourseId', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_SEMESTERS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getSubjectsByCourseSemesterId({ commit }, params) {
      try {
        const response = await axios.get('uni/subjects/getByCourseSemesterId', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_SUBJECTS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getCreditClassesByCourseSemesterAndSubject({ commit }, params) {
      try {
        const response = await axios.get('uni/credit_classes/getByCourseSemesterAndSubject', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_CREDIT_CLASSES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async countAlphabetPointCreditClass({ commit }, params) {
      try {
        const response = await axios.get('uni/studentsCreditClasses/countAlphabetPointCreditClass', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_POINTS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getAlphabetPointCreditClass({ commit }, params) {
      try {
        const response = await axios.get('uni/studentsCreditClasses/getAlphabetPointCreditClass', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_STUDENTS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
